import { render, staticRenderFns } from "./MenuActionPayments.vue?vue&type=template&id=76c901ee&"
import script from "./MenuActionPayments.vue?vue&type=script&lang=js&"
export * from "./MenuActionPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports